import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Image from '../../elements/Image';
import LogoIm from './../../../assets/images/canoe-logo-banner.svg'

const Logo = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'brand',
    className
  );

  return (
    <div
      {...props}
      className={classes}
    >
      <h1 className="m-0">
        <Link to="/">
          <Image
            src={LogoIm}
            alt="Open"
            width={130}
            height={0} />
        </Link>
      </h1>
    </div>
  );
}

export default Logo;